/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createActivityGalleryImage } from '../fn/activity-gallery/create-activity-gallery-image';
import { CreateActivityGalleryImage$Params } from '../fn/activity-gallery/create-activity-gallery-image';
import { deleteActivityGalleryImageById } from '../fn/activity-gallery/delete-activity-gallery-image-by-id';
import { DeleteActivityGalleryImageById$Params } from '../fn/activity-gallery/delete-activity-gallery-image-by-id';
import { galleryByActivityId } from '../fn/activity-gallery/gallery-by-activity-id';
import { GalleryByActivityId$Params } from '../fn/activity-gallery/gallery-by-activity-id';
import { ResponseDeleteGalleryImage } from '../models/response-delete-gallery-image';
import { ResponseGalleryImage } from '../models/response-gallery-image';

@Injectable({ providedIn: 'root' })
export class ActivityGalleryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `galleryByActivityId()` */
  static readonly GalleryByActivityIdPath = '/rest/activity/{id}/gallery';

  /**
   * Get gallery for activity.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `galleryByActivityId()` instead.
   *
   * This method doesn't expect any request body.
   */
  galleryByActivityId$Response(params: GalleryByActivityId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResponseGalleryImage>>> {
    return galleryByActivityId(this.http, this.rootUrl, params, context);
  }

  /**
   * Get gallery for activity.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `galleryByActivityId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  galleryByActivityId(params: GalleryByActivityId$Params, context?: HttpContext): Observable<Array<ResponseGalleryImage>> {
    return this.galleryByActivityId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ResponseGalleryImage>>): Array<ResponseGalleryImage> => r.body)
    );
  }

  /** Path part for operation `createActivityGalleryImage()` */
  static readonly CreateActivityGalleryImagePath = '/rest/activity/{id}/gallery';

  /**
   * Add gallery image to existing activity.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createActivityGalleryImage()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createActivityGalleryImage$Response(params: CreateActivityGalleryImage$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseGalleryImage>> {
    return createActivityGalleryImage(this.http, this.rootUrl, params, context);
  }

  /**
   * Add gallery image to existing activity.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createActivityGalleryImage$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createActivityGalleryImage(params: CreateActivityGalleryImage$Params, context?: HttpContext): Observable<ResponseGalleryImage> {
    return this.createActivityGalleryImage$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponseGalleryImage>): ResponseGalleryImage => r.body)
    );
  }

  /** Path part for operation `deleteActivityGalleryImageById()` */
  static readonly DeleteActivityGalleryImageByIdPath = '/rest/activity/{activityId}/gallery/{id}';

  /**
   * Delete gallery image. Activity Gallery Image (defined by id) must belongs to Activity (defined by activityId).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteActivityGalleryImageById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteActivityGalleryImageById$Response(params: DeleteActivityGalleryImageById$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseDeleteGalleryImage>> {
    return deleteActivityGalleryImageById(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete gallery image. Activity Gallery Image (defined by id) must belongs to Activity (defined by activityId).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteActivityGalleryImageById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteActivityGalleryImageById(params: DeleteActivityGalleryImageById$Params, context?: HttpContext): Observable<ResponseDeleteGalleryImage> {
    return this.deleteActivityGalleryImageById$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponseDeleteGalleryImage>): ResponseDeleteGalleryImage => r.body)
    );
  }

}
